export const AnalyticsCategories = {
  login: "Login",
  advertisers: "Advertisers",
  advertiserTableRow: "Advertiser Table Row",
  advertiserCarousel: "Advertiser Carousel",
  busRequests: "Bus Requests",
  newsManagement: "News Management",
  providers: "Providers",
  providersTableRow: "Providers Table Row",
  RequestTableRow: "Request Table Row",
  users: "Users",
  userTableRow: "User Table Row",
  advertiserModalContent: "Advertiser Modal Content",
  exportCsvContent: "Export CSV Content",
  imageChooserModalContent: "Image Chooser Modal Content",
  providerModalContent: "Provider Modal Content",
  requestModalContent: "Request Modal Content",
  userModalContent: "User Modal Content",
  fleet: "Fleet",
  fleetTableRow: "Fleet Table Row",
  fleetAddModalContent: "Fleet Add Modal Content",
  loggedOutBanner: "Logged Out Banner",
  homeNewsModalContent: "Home News Modal Content",
  calendarRequest: "Calendar Request",
  management: "Management",
  createEmergencyModalContent: "Create Emergency Modal Content",
  createEmptyRideModalContent: "Create Empty Ride Modal Content",
  createGroupRequestModalContent: "Create Group Reques Modal Content",
  createVacancyModalContent: "Create Vacancy Modal Content",
  managementModalContent: "Management Modal Content",
  languageSelector: "Language Selector",
  loggedInNavbar: "Logged In Navbar",
  navbar: "Navbar",
  news: "News",
  newsArticlePreview: "News Article Preview",
  companyProfile: "Company Profile",
  locationTable: "Location Table",
  locationTableRow: "Location Table Row",
  userProfile: "User Profile",
  companyProfileEditModalContent: "Company Profile Edit Modal Content",
  locationAddEdiModalContent: "Locaion Add Edit Modal Content",
  passwordChangeModalConent: "Password Change Modal Content",
  userProfileEditModalContent: "User Profile Edit Modal Content",
  register: "Register",
  stepperbar: "Stepperbar",
  registerErrorModalContent: "Register Error Modal Content",
  singleRequestSubmittedModalContent: "Single Reques Submitted Modal Content",
  advertiserLocationsModalContent: "Advertiser Locations Modal Content",
  advertiserLocationTableRow: "Advertiser Location Table Row",
  travelService: "Travel Service",
  busRequestFilterBar: "Bus Requesdt Filter Bar",
  helperBus: "Helper Bus",
  modal: "Modal",
  checkboxFormField: "Checkbox Form Field",
  clusterRequestModalContent: "Cluster Request Modal Content",
  paginatedPDF: "Paginated PDF",
  busRequestTableRow: "Bus Request Table Row",
  pagination: "Pagination",
  contact: "Contact",
  forgotPassword: "Forgot Password",
  singleRequestView: "Single Request View",
  publicCompanyProfile: "Public Company Profile",
  adminPanel: "Admin Panel",
  newsEditor: "News Editor",
  home: "Home",
  buspartner: "Bus Partner",
  companyContact: "Company Contact",
  companyDescription: "Company Description",
  map: "Map",
  newsHomeModalContent: "News Home Modal Content",
  pdfViewer: "PDF Viewer",
  footer: "Footer",
  imprint: "Imprint",
  landingPageBusCompany: "Landing Page Bus Company",
  locationContact: "Location Contact",
  placeAutocomplete: "Place Autocomplete",
  gdprCookiesInfo: "GDPR Cookies Info",
  gdprCookiesSettings: "GDPR Cookies Settings",
  csvUtils: "CSV Utils",
  deleteAccount: "Delete Account",
  webVitals: "Web Vitals",
  nextJS: "Next.js custom metric",
} as const;

export type AnalyticsCategories =
  (typeof AnalyticsCategories)[keyof typeof AnalyticsCategories];

export const AnalyticsActions = {
  formSubmitted: "Form Submitted",
  submitFormClick: "Submit Form Click",
  loggedIn: "Logged In",
  userNotActivated: "User Not Activated",
  invalidLoginData: "Invalid Login Data",
  loginClick: "Login Click",
  refreshClick: "Refresh Click",
  exportCsvClick: "Export CSV Click",
  editClick: "Edit Click",
  deleteClick: "Delete Click",
  newClick: "New Click",
  addClick: "Add Click",
  okClick: "OK Click",
  removeClick: "Remove Click",
  filterClick: "Filter Click",
  activeClick: "Active Click",
  resetPasswordClick: "Reset Password Click",
  cancelClick: "Cancel Click",
  uploadImageClick: "Upload Image Click",
  imageClick: "Image Click",
  updateClick: "Update Click",
  acceptClick: "Accept Click",
  addBusClick: "Add Bus Click",
  qrClick: "QR Click",
  forgotPassword: "Forgot Password",
  rentBusClick: "Rent Bus Click",
  calendarClick: "Calendar Click",
  addGroupRequestClick: "Add Group Request Click",
  addVacancyClick: "Add Vacancy Click",
  addEmptyRideClick: "Add Empty Ride Click",
  addEmergencyClick: "Add Emergency Click",
  filterGroupRequestClick: "Filter Group Request Click",
  filterVacancyClick: "Filter Vacancy Click",
  filterEmptyRideClick: "Filter Empty Ride Click",
  filerEmergencyClick: "Filer Emergency Click",
  changedLanguage: "Changed Language",
  languageClick: "Language Click",
  userLoggedOut: "User logged Out",
  loggoutClick: "Loggout Click",
  scrollToTopClick: "Scroll To Top Click",
  newsClick: "News Click",
  addLocationClick: "Add Location Click",
  editLocationClick: "Edit Location Click",
  removeLocationClick: "Remove Location Click",
  changePasswordClick: "Change Password Click",
  resetImageClick: "Reset Image Click",
  uploadPdfClick: "Upload PDF Click",
  resetPdfClick: "Reset PDF Click",
  registeredAccount: "Registered Account",
  signupClick: "Signup Click",
  stepperClick: "Stepper Click",
  showCompanyContactClick: "Show Company Contact Click",
  showDetailsClick: "Show Details Click",
  toggleHelperBusClick: "Toggle Helper Bus Click",
  containerClick: "Container Click",
  modalMainClick: "Modal Main Click",
  checkboxClick: "Checkbox Click",
  checkboxContainerClick: "Checkbox Container Click",
  headerRightButtonClick: "Header Right Button Click",
  showRequesDescriptionClick: "Show Request Description Click",
  openedClusterModal: "Opened Cluster Modal",
  leftPageClick: "Left Page Click",
  rightPageClick: "Right Page Click",
  pageClick: "Page Click",
  pateDotsClick: "Page Dots Click",
  openedPDF: "Opened PDF",
  detailsClick: "Details Click",
  changedPassword: "Changed Password",
  fetchData: "Fetch Data",
  setupUserData: "Setup User Data",
  uploadArticle: "Upload Article",
  sendData: "Send Data",
  useEffect: "UseEffect",
  saveClick: "Save Click",
  externalLinkClick: "External Link Click",
  autocompleteLocation: "Autocomplete Location",
  gdprCookieSettingsClick: "GDPR Cookie Settings Click",
  declineAllGdprCookiesClick: "Decline All GDPR Cookies Click",
  acceptAllGdprCookiesClick: "Accept All GDPR Cookies Click",
  openGdprCookiesSettingsClick: "Open GDPR Cookies Settings",
  toggleGdprCookiesClick: "Toggle GDPR Cookies Click",
  acceptGdprCookiesClick: "Accept GDPR Cookies Click",
  closeGdprCookiesSettingsClick: "Close GDPR Cookies Settings Click",
  download: "Download",
  adClick: "Advertisement Click",
  deleteAccount: "Delete Account",
} as const;

export type AnalyticsActions =
  (typeof AnalyticsActions)[keyof typeof AnalyticsActions];

export const AnalyticsLabels = {
  encounteredHTTPError: "Encountered HTTP Error",
  Logout: "Logout",
  user: "User",
  map: "Map",
  button: "Button",
  filter: "Filter",
  clusterMarker: "Cluser Marker",
  locationNotFound: "Location Not Found",
  locationFound: "Location Found",
  CSV: "CSV",
  groupRequest: "grouprequest",
  emptyride: "emptyride",
  vacancy: "vacancy",
  emergency: "emergency",
  UpdateRequest: "UpdateRequest",
  UpdateCompany: "UpdateCompany",
  UpdateContactData: "UpdateContactData",
  UpdateUser: "UpdateUser",
  UpdateBus: "UpdateBus",
  AddBus: "AddBus",
  RemoveBus: "RemoveBus",
  SendFeedback: "SendFeedback",
  ResetPassword: "ResetPassword",
  AddRequest: "AddRequest",
  RemoveRequest: "RemoveRequest",
  GetAdvertiserLocations: "GetAdvertiserLocations",
  RemoveAdvertiserLocation: "RemoveAdvertiserLocation",
  GetAdvertiserRequests: "GetAdvertiserRequests",
  DeleteAccount: "DeleteAccount",
  UpdateAdvertiserLocation: "UpdateAdvertiserLocation",
  AddAdvertiserLocation: "AddAdvertiserLocation",
  ChangePassword: "ChangePassword",
  Register: "Register",
  GetCompany: "GetCompany",
  GetPublicDataForCompany: "GetPublicDataForCompany",
} as const;

export type AnalyticsLabels =
  (typeof AnalyticsLabels)[keyof typeof AnalyticsLabels];

export const AnalyticsEventType = {
  Event: "event",
  Timing: "timing",
  Error: "error",
  PageView: "pageview",
} as const;

export type AnalyticsEventType =
  (typeof AnalyticsEventType)[keyof typeof AnalyticsEventType];
